"use client";

import React, { useState } from "react";
import { STATE_LIST } from "../templates/values/state";
import { CustomLink } from "./CustomLink";

const CharityByCategoryList = ({ charityList }) => {
  const [filterArray, setFilterArray] = useState(charityList);
  const [filterValue, setFilterValue] = useState({
    ein: "",
    name: "",
    city: "",
    state: ""
  });

  const handleFilter = (e) => {
    const key = e.target.getAttribute("name");
    const value = e.target.value.toLowerCase();

    const filteredEin = key === "ein" ? value : filterValue.ein;
    const filteredName = key === "name" ? value : filterValue.name;
    const filteredCity = key === "city" ? value : filterValue.city;
    const filteredState = key === "state" ? value : filterValue.state;

    setFilterValue((prevState) => ({
      ...prevState,
      [key]: value // Update only the value for the changed key
    }));

    let filterData = [];

    if (
      filteredEin !== ""
      || filteredName !== ""
      || filteredCity !== ""
      || filteredState !== ""
    ) {
      filterData = charityList
        .filter((item) => {
          let matchState = [];
          if (filteredState) {
            matchState = STATE_LIST.filter(
              (state) =>
                state.name.startsWith(filteredState)
                || state.abbreviation.startsWith(filteredState)
            );
          }

          return (
            item?.ein?.startsWith(filteredEin)
            && item?.name?.toLowerCase().includes(filteredName.toLowerCase())
            && item?.city?.toLowerCase().includes(filteredCity.toLowerCase())
            && (matchState.length === 0 && !filteredState
              ? charityList
              : charityList.filter((item) => {
                // TODO: Refactor this
                // eslint-disable-next-line no-restricted-syntax
                for (const state of matchState) {
                  if (
                    item?.state?.toLowerCase()?.startsWith(state.abbreviation)
                  ) {
                    return true;
                  }
                }
                return false;
              })
            ).includes(item)
          );
        })
        .sort((a, b) => a[key].localeCompare(b[key]));
    } else {
      filterData = charityList;
    }
    setFilterArray(filterData);
  };

  function TitleCase(str) {
    return str.replace(
      /(\w)(\w*)/g,
      (_, firstChar, rest) => firstChar + rest.toLowerCase()
    );
  }

  return (
    <>
      <div className="min-w-[850px] rounded bg-[#C7FCE540] px-4 py-2 shadow-[0px_4px_24px_0px_#00000014]">
        <div className="grid grid-cols-7 gap-4">
          <div className="col-span-1 border-b-2 border-[#D4D4D4] px-1 py-2 font-semibold ">
            EIN
          </div>
          <div className="col-span-2 border-b-2 border-[#D4D4D4] px-1 py-2 font-semibold">
            Organization Name
          </div>
          <div className="col-span-1 border-b-2 border-[#D4D4D4] px-1 py-2 font-semibold">
            City
          </div>
          <div className="col-span-1 border-b-2 border-[#D4D4D4] px-1 py-2 font-semibold">
            State
          </div>
          <div className="col-span-2 border-b-2 border-[#D4D4D4] px-1 py-2 font-semibold">
            Information
          </div>
        </div>
        <div className="my-2 grid min-h-[80px] grid-cols-7 items-center gap-4 rounded bg-[#F1F1F1] px-2 py-1">
          <div className=" col-span-1 p-2">
            <input
              className="w-full p-1 outline-none"
              placeholder="Enter EIN"
              name="ein"
              value={filterValue.ein}
              onChange={handleFilter}
            />
          </div>
          <div className=" col-span-2 px-1 py-2 ">
            {" "}
            <input
              className="w-full p-1 outline-none"
              placeholder="Enter Organization Name"
              name="name"
              value={filterValue.name}
              onChange={handleFilter}
            />
          </div>
          <div className=" col-span-1 px-1 py-2 ">
            {" "}
            <input
              className="w-full p-1 outline-none"
              placeholder="Enter City"
              name="city"
              value={filterValue.city}
              onChange={handleFilter}
            />
          </div>
          <div className=" col-span-1 px-1 py-2 ">
            {" "}
            <input
              className="w-full p-1 outline-none"
              placeholder="Enter State"
              name="state"
              value={filterValue.state}
              onChange={handleFilter}
            />
          </div>
          <div className=" col-span-1 px-1 py-2"> </div>
          <div className=" col-span-1 px-1 py-2"> </div>
        </div>
        {filterArray
          ?.filter((item) => item.ein !== null)
          .map((item) => (
            <div
              key={item.ein}
              className="my-2 grid min-h-[80px] grid-cols-7 items-center gap-4 rounded bg-white px-2 py-1 transition-all hover:bg-primary"
            >
              <div className="col-span-1 flex justify-start p-2 text-sm hover:font-bold">
                {item.ein}
              </div>
              <div className=" col-span-2 flex cursor-pointer justify-start px-1 py-2 text-[#0D82EE] underline">
                {" "}
                <CustomLink
                  href={`/nonprofit/ein-${item?.ein}/`}
                >
                  {item.name}
                </CustomLink>
              </div>
              <div className=" col-span-1 flex justify-start px-1 py-2">
                {" "}
                {TitleCase(item.city)}
              </div>
              <div className=" col-span-1 flex justify-start px-1 py-2 ">
                {" "}
                {item.state}
              </div>
              <div className="col-span-2 flex px-1 py-2 text-[#0D82EE] ">
                <CustomLink
                  href={`/nonprofit/ein-${item?.ein}/`}
                  className="mx-1"
                >
                  {" "}
                  Mission,{" "}
                </CustomLink>
                <CustomLink
                  href={`/nonprofit/ein-${item?.ein}/#financials`}
                >
                  {" "}
                  Revenue,{" "}
                </CustomLink>
                <CustomLink
                  href={`/nonprofit/ein-${item?.ein}/`}
                  className="mx-1"
                >
                  {" "}
                  Legitimacy, CEO Salary{" "}
                </CustomLink>
              </div>
            </div>
          ))}
        {filterArray?.length === 0 && (
          <div
            style={{ textAlign: "center" }}
            className="flex flex-col items-center justify-center bg-white py-4 text-gray-400"
          >
            <p>Data Not Found</p>
          </div>
        )}
      </div>
    </>
  );
};

export default CharityByCategoryList;
